import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { EVENT_BUS } from '@shared/domain/tokens/event-bus.token';
import { AppDisconnectedEvent } from '@platform/event-bus/domain/events/app-disconnected.event';
import { PermissionStore } from '../../application/stores/permission.store';

@Injectable({ providedIn: 'root' })
export class PermissionCleanDataSubscriber {
  private readonly eventBus = inject(EVENT_BUS);
  private readonly destroyRef = inject(DestroyRef);
  private readonly permissionStore = inject(PermissionStore);

  constructor() {
    this.eventBus.ofType(AppDisconnectedEvent).pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(() => {
      this.permissionStore.clear();
    });
  }
}

